module.exports = __webpack_public_path__ + "static/media/wellness.a424a2c7.png";